import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
const columns = [
  {
    label: "Investments",
    className: "column-planName col-md-3",
    columnName: "investment",
    innerColumns: false,
  },
  {
    label: "Opening balance",
    className: "column-status col-md-3",
    columnName: "openingBalance",
    innerColumns: true,
  },
  {
    label: "Transactions for the period",
    className: "column-status col-md-3",
    columnName: "transactionsForPeriod",
    innerColumns: true,
  },
  {
    label: "Closing balance",
    className: "column-status col-md-3",
    columnName: "closingBalance",
    innerColumns: true,
  },
];
const innerColumns = [
  {
    label: "Regular account",
    className: "col-md",
    columnName: "regularAccount",
  },
  {
    label: "Earnings A/c",
    className: "col-md",
    columnName: "earningsAccount",
  },
  {
    label: "Unvested A/c",
    className: "col-md",
    columnName: "unvestedAccount",
  },
];
const data = [
  {
    investment: "investment1",
    openingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    transactionsForPeriod: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    closingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
  },
  {
    investment: "investment2",
    openingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    transactionsForPeriod: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    closingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
  },
  {
    investment: "investment3",
    openingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    transactionsForPeriod: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
    closingBalance: {
      regularAccount: 100,
      earningsAccount: 100,
      unvestedAccount: 100,
    },
  },
];
export const ParticipantInvestmentTable = () => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => {
            if (e.columnName === "investment") {
              return (
                <Table.Th className="inner-columns-report-table">
                  {e.label}
                </Table.Th>
              );
            }
            return (
              <Table.Th className="table-width-30 justify-content-center">
                {e.label}
              </Table.Th>
            );
          })}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          {columns.map((f, j) => {
            if (f.innerColumns) {
              return innerColumns.map((e, i) => (
                <Table.Td className="inner-columns-report-table">
                  {e.label}
                </Table.Td>
              ));
            }
            return <Table.Td className="inner-columns-report-table"></Table.Td>;
          })}
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) => {
              if (f.columnName === "investment") {
                return (
                  <Table.Td className="inner-columns-report-table">
                    {e[f.columnName]}
                  </Table.Td>
                );
              }
              return innerColumns.map((g, k) => (
                <Table.Td className="inner-columns-report-table">
                  {e[f.columnName][g.columnName]}
                </Table.Td>
              ));
              // e[f.columnName].map((g,k) => <Table.Td className="inner-columns-report-table">{g[f.columnName]}</Table.Td>)
            })}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
